import React, { useEffect, useState } from 'react';
import { ClipLoader } from "react-spinners";
import { motion } from "framer-motion";

const About = () => {
  const [data, setData] = useState(null);

   useEffect(() => {
     fetch("/data/aboutData.json")
       .then((res) => res.json())
       .then((data) => setData(data))
       .catch((err) => console.error("Failed to load about data:", err));
   }, []);

  if (!data) return (
    <motion.div 
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  exit={{ opacity: 0 }}
  transition={{ duration: 0.3 }}
  className="min-h-screen"
>
    <div className="w-full flex justify-center items-center h-32">
      <ClipLoader color="#fff" size={40} />
    </div>
    </motion.div>
  );

  return (
    <motion.div 
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  exit={{ opacity: 0 }}
  transition={{ duration: 0.3 }}
  className="min-h-screen"
>
      <section className="section container px-6">
        <div>
          <h1 className="heading-main text-center mb-4">About Me</h1>
          <p className="text-xl text-gray-300 mb-8">{data.intro}</p>

          <h2 className="heading-sub mb-4">My Journey</h2>
          <p className="text-lg text-gray-300 mb-8">{data.journey}</p>

          <h2 className="heading-sub mb-4">Skills & Expertise</h2>
          <p className="text-lg text-gray-300 mb-8">{data.skills}</p>

          <h2 className="heading-sub mb-4">Technologies I Use</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 mb-8">
            {data.technologies.map((tech, index) => (
              <div
                key={index}
                className="text-lg text-gray-800 p-4 bg-gray-200 rounded-lg shadow-md hover:bg-gray-300 transition-colors duration-300"
              >
                {tech}
              </div>
            ))}
          </div>

          <h2 className="heading-sub mb-4">What I’m Learning</h2>
          <p className="text-lg text-gray-300 mb-8">{data.learning}</p>
          {data.certifications && data.certifications.length > 0 && (
  <>
    <h2 className="heading-sub mb-4">Certifications</h2>
    <ul className="text-lg text-gray-300 mb-8 space-y-2">
      {data.certifications.map((cert, index) => (
        <li key={index}>
          <a
            href={cert.link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-300 hover:text-gray-400"
          >
            {cert.name} {cert.year ? `(${cert.year})` : ""}
          </a>
        </li>
      ))}
    </ul>
  </>
)}
        </div>
      </section>
      </motion.div>
  );
};

export default About;
